import { Record } from 'immutable'
import _ from 'lodash'

export interface ZendeskSetting {
  widgetUrl: string
  widgetId: string
  widgetSnippetKey: string
}

const properties = {
  minimumAppVersion: 0,
  minimumAppVersionAndroid: 0,
  zendesk: undefined,
}

export default class Setting extends Record(properties, 'Setting') implements Setting {
  minimumAppVersion!: number

  minimumAppVersionAndroid!: number

  zendesk?: ZendeskSetting

  constructor(values: any = {}) {
    super(_.pick(values, Object.keys(properties)))
  }
}
